import { useContextProductData } from "@/Context/Product/ContextProductProvider";
import useWindowsSize from "@/Hooks/useWindowsSize";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper";
import { Navigation, Pagination } from "swiper/modules";

type PropsImages = {
  headdleOpen: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const DataViewModal = ({ headdleOpen }: PropsImages) => {
  const { width, height } = useWindowsSize();
  //const sourceImage = [uno, dos, tres, uno];
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [activeIn, setActiveIn] = useState<number>(0);
  const [mostrar, setMostrar] = useState<boolean>(false);
  const swiperRef = useRef<SwiperClass | null>(null);
  const { Products } = useContextProductData();
  const Productos = Products.map((item) => item)[0];
  swiperRef.current?.slideToLoop(activeIndex, 0); // Mover al slide con índice 'reference' sin animación
  const [downloadImg, setDownloadImg] = useState<string>("");

  const sourceImageV2 = Productos?.ImageZoomGroups?.map((x) => {
    const allLinks = x?.images?.flatMap((t) => t.link);
    return allLinks;
  })[0];

  const handdlerImage = (index: number) => {
    const imgs = sourceImageV2?.map((x) => x)[index];
    setActiveIndex(index);
    setDownloadImg(imgs ?? "");
    setActiveIn(index + 1);
  };

  const headdleNext = () => {
    //setActiveIndex((prev) => (prev + 1) % sourceImage.length);
    const maxIndex = Math.min(
      activeIndex + 1,
      Number(sourceImageV2?.length) - 1
    );
    setActiveIndex(maxIndex);
    setActiveIn(maxIndex + 1);
  };

  const headdlePrev = () => {
    const newIndex = Math.max(activeIndex - 1, 0);
    setActiveIndex(newIndex);
    setActiveIn(newIndex);
  };

  const headdleView = () => setMostrar((prev) => !prev);

  return (
    <div
      className={`lg-outer lg-start-zoom lg-use-css3 lg-css3 lg-slide lg-show-after-load lg-pull-caption-up lg-has-thumb lg-can-toggle lg-use-transition-for-zoom lg-visible lg-grab ${
        mostrar ? "lg-thumb-open" : ""
      }`}>
      <div className="lg" style={{ width: "100%", height: "100%" }}>
        <div className="lg-toolbar lg-group" style={{ opacity: "2" }}>
          <span className="lg-close lg-icon" onClick={headdleOpen}></span>
          <Link
            id="lg-download"
            target="_blank"
            download=""
            className="lg-download lg-icon"
            to={downloadImg != "" ? downloadImg : ""}></Link>
          <div id="lg-counter">
            <span id="lg-counter-current">{activeIndex + 1}</span> /{" "}
            <span id="lg-counter-all">{sourceImageV2?.length}</span>
          </div>
        </div>
        <div
          className="lg-inner flex items-center justify-center h-full"
          style={{
            transitionTimingFunction: "ease",
            transitionDuration: "600ms",
          }}>
          <div className="d-flex vh-100">
            <Swiper
              modules={[Navigation, Pagination]}
              slidesPerView={1}
              onSlideChange={(swiper) => {
                setActiveIndex(swiper.realIndex);
                setDownloadImg(downloadImg);
                setActiveIn(swiper.realIndex + 1);
              }}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              className="w-100 flex items-center justify-center">
              {sourceImageV2?.map((img, index) => (
                <SwiperSlide key={index} className="h-full d-flex">
                  <img
                    className="d-flex align-items-center mx-auto my-auto"
                    src={img}
                    width={`${
                      width > 998 && width < 1200
                        ? "70%"
                        : width > 1200 && width < 1330
                        ? "60%"
                        : width > 1330 && width < 1670
                        ? "50%"
                        : width >= 1670
                        ? "40%"
                        : "90%"
                    }`}
                    alt={`image ${index}`}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div
          className="lg-actions"
          style={{ opacity: width > 768 ? "1" : "0" }}>
          <button
            className="lg-prev lg-icon"
            style={{ opacity: activeIn === 0 ? "0" : "1" }}
            onClick={headdlePrev}></button>
          <button
            className="lg-next lg-icon"
            style={{
              opacity: activeIn === Number(sourceImageV2?.length) ? "0" : "1",
            }}
            onClick={headdleNext}></button>
        </div>
        <div className="lg-sub-html lg-empty-html"></div>
        <div className="lg-progress-bar">
          <div className="lg-progress"></div>
        </div>
        {/*Imagenes*/}
        <div
          className="lg-thumb-outer lg-grab d-flex mt-3"
          style={{ height: "100px" }}>
          <div
            className="lg-thumb lg-group"
            style={{
              width: "100%",
              position: "relative",
              transform: "translate3d(0px, 0px, 0px)",
            }}>
            {sourceImageV2?.map((img, index) => (
              <div
                key={index}
                data-vimeo-id=""
                className={`lg-thumb-item ${
                  index === activeIndex ? "active" : ""
                }`}
                style={{ width: "100px", height: "100%", marginRight: "5px" }}
                onClick={() => handdlerImage(index)}>
                <img src={img} alt={`Thumb ${index}`} />
              </div>
            ))}
          </div>
          <span
            className="lg-toogle-thumb lg-icon"
            onClick={headdleView}></span>
        </div>
      </div>
    </div>
  );
};

export default DataViewModal;
